import React, { useState } from 'react';
import { useTranslate } from 'react-admin';
import { Button, Dialog, DialogContent, DialogTitle, Tooltip, Typography, useTheme } from '@mui/material';
import { listActionsColumnIconCommonStyle } from '../../themes/commonStyles';
import { isAdminPermissions } from '../../helper/resourceHelper';
import DeviceShares from '../../pages/device/shares/DeviceShares';


const Icon = ({ color }) => {
    return (<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke={color} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="icon icon-tabler icons-tabler-outline icon-tabler-share"><path stroke="none" d="M0 0h24v24H0z" fill="none" /><path d="M6 12m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" /><path d="M18 6m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" /><path d="M18 18m-3 0a3 3 0 1 0 6 0a3 3 0 1 0 -6 0" /><path d="M8.7 10.7l6.6 -3.4" /><path d="M8.7 13.3l6.6 3.4" /></svg>
    )
}


const ShareDialog = ({ open, setOpen, deviceId }) => {
    const translate = useTranslate();
    const theme = useTheme();

    return (
        <Dialog
            open={open}
            onClose={() => { }}
            fullWidth
            maxWidth="sm"
            sx={{
                "& .MuiPaper-root": {
                    margin: "10px",
                    padding: "0px"
                }
            }}
        >
            <DialogTitle sx={{ display: "flex", flexDirection: 'row', justifyContent: "center", padding: "20px 20px 0px 20px" }}>
                <Typography sx={{ fontSize: "16px", fontWeight: 500, color: theme.palette.text.primary }}>{translate('resources.devices.shares.title')}</Typography>
            </DialogTitle>
            <DialogContent sx={{ padding: "20px" }}>
                <DeviceShares deviceId={deviceId} onClose={() => { setOpen(false); }} />
            </DialogContent>
        </Dialog>
    )
}


const ShareButton = ({
    record = {},
    disabled = false,
}) => {
    const translate = useTranslate();
    const theme = useTheme();
    const [openDialog, setOpenDialog] = useState(false);

    if (!record || !record.id || !isAdminPermissions()) {
        return (null)
    }

    return (
        <>
            <Tooltip title={translate('resources.devices.labels.share_location')} disableInteractive>
                <Button
                    disabled={disabled}
                    sx={listActionsColumnIconCommonStyle({ isLastItem: true })}
                    onClick={() => { setOpenDialog(true); }}
                >
                    <Icon color={disabled ? theme.palette.grey[400] : theme.palette.primary.main} />
                </Button>
            </Tooltip>
            {openDialog && <ShareDialog deviceId={record.id} open={openDialog} setOpen={setOpenDialog} />}
        </>
    )
};


export default ShareButton;
